// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.useCaseBreadCrumb {
    font-size: 14px;
    border: 1px solid var(--integration-border-color);
    border-radius: 15px;
    margin-right: 8px;
    margin-bottom: 5px;
    padding: 0px 14px;
    height: 30px;
    flex-shrink: 0;
}

    .useCaseBreadCrumb.bcSelected {
        border-color: transparent;
        background-color: var(--integration-text-color);
        color: var(--integration-background);
    }

.useCaseGroupHeader {
    font-size: 14px;
    color: var(--integration-text-color);
    font-weight: 600;
}

.useCaseGroupDIV {
    margin-bottom: 20px;
}

.useCaseBox {
    font-size: 14px;
    color: var(--integration-text-color);
    border: 1px solid var(--integration-border-color);
    border-radius: 10px;
    margin: 20px 20px 0px 0px;
    height: 40px;
    width: 168px;
    justify-content: center;
    padding: 1px;
}

    .useCaseBox.ucSelected {
        border: 2px solid var(--integration-text-color);
        padding: 0px;
    }

    .useCaseBox > span {
        align-self: center;
        overflow: hidden;
        text-overflow: ellipsis;
        margin: 0px 14px;
        white-space: nowrap;
    }

.p-input-icon-left {
    font-size: 15px;
    align-self: flex-start;
    margin-bottom: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/app/integration/smartintegration/smartintegrationwizard/siw.use.case.page.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,iDAAiD;IACjD,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;IACZ,cAAc;AAClB;;IAEI;QACI,yBAAyB;QACzB,+CAA+C;QAC/C,oCAAoC;IACxC;;AAEJ;IACI,eAAe;IACf,oCAAoC;IACpC,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,oCAAoC;IACpC,iDAAiD;IACjD,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,uBAAuB;IACvB,YAAY;AAChB;;IAEI;QACI,+CAA+C;QAC/C,YAAY;IAChB;;IAEA;QACI,kBAAkB;QAClB,gBAAgB;QAChB,uBAAuB;QACvB,gBAAgB;QAChB,mBAAmB;IACvB;;AAEJ;IACI,eAAe;IACf,sBAAsB;IACtB,mBAAmB;AACvB","sourcesContent":[".useCaseBreadCrumb {\n    font-size: 14px;\n    border: 1px solid var(--integration-border-color);\n    border-radius: 15px;\n    margin-right: 8px;\n    margin-bottom: 5px;\n    padding: 0px 14px;\n    height: 30px;\n    flex-shrink: 0;\n}\n\n    .useCaseBreadCrumb.bcSelected {\n        border-color: transparent;\n        background-color: var(--integration-text-color);\n        color: var(--integration-background);\n    }\n\n.useCaseGroupHeader {\n    font-size: 14px;\n    color: var(--integration-text-color);\n    font-weight: 600;\n}\n\n.useCaseGroupDIV {\n    margin-bottom: 20px;\n}\n\n.useCaseBox {\n    font-size: 14px;\n    color: var(--integration-text-color);\n    border: 1px solid var(--integration-border-color);\n    border-radius: 10px;\n    margin: 20px 20px 0px 0px;\n    height: 40px;\n    width: 168px;\n    justify-content: center;\n    padding: 1px;\n}\n\n    .useCaseBox.ucSelected {\n        border: 2px solid var(--integration-text-color);\n        padding: 0px;\n    }\n\n    .useCaseBox > span {\n        align-self: center;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        margin: 0px 14px;\n        white-space: nowrap;\n    }\n\n.p-input-icon-left {\n    font-size: 15px;\n    align-self: flex-start;\n    margin-bottom: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
